import type { FC } from "react";
import { DashboardCardSlider } from "web_myplann/Dashboard/Components/DashboardCardSlider";
import type { AnimationDirection } from "web_myplann/Dashboard/Hooks/useDashboardAnimation";
import { useIsDashboardV2 } from "web_myplann/Dashboard/State/dashboardVariantContext";
import type { DashboardType } from "web_myplann/Dashboard/Types/DashboardType";
import { DashboardAnimatedContent } from "./DashboardAnimatedContent";

type Props = {
	dashboard: DashboardType;
	previousDashboard: DashboardType | null;
	isAnimating: boolean;
	animationDirection: AnimationDirection;
	isDashboardDetail?: boolean;
	navigateToDashboardDetail?: () => void;
	onTooltipToggle?: (open: boolean) => void;
};

export const DashboardCardCarouselResolver: FC<Props> = ({
	dashboard,
	previousDashboard,
	isAnimating,
	animationDirection,
	isDashboardDetail,
	navigateToDashboardDetail,
	onTooltipToggle,
}) => {
	const isDashboardV2 = useIsDashboardV2();

	if (isDashboardV2 && !isDashboardDetail) {
		return (
			<DashboardCardSlider
				dashboard={dashboard}
				direction={animationDirection}
				navigateToDashboardDetail={navigateToDashboardDetail}
				onTooltipToggle={onTooltipToggle}
			/>
		);
	}

	return (
		<>
			<DashboardAnimatedContent
				dashboardData={dashboard}
				isAnimating={isAnimating}
				isPrevious={false}
				animationDirection={animationDirection}
				isDashboardDetail={isDashboardDetail}
				navigateToDashboardDetail={navigateToDashboardDetail}
				onTooltipToggle={onTooltipToggle}
			/>

			{isAnimating && previousDashboard && (
				<DashboardAnimatedContent
					dashboardData={previousDashboard}
					isAnimating={isAnimating}
					isPrevious={true}
					animationDirection={animationDirection}
					isDashboardDetail={isDashboardDetail}
					navigateToDashboardDetail={navigateToDashboardDetail}
				/>
			)}
		</>
	);
};
